// Shared look for the Cycle Clock's parts (DWLF-301).
export const tok = (t) => `var(--dwlf-${t})`;
export const LABEL = { fontFamily: '"Space Mono", monospace', textTransform: 'uppercase', letterSpacing: '0.12em' };
export const weeks = (v) => (Number.isFinite(v) ? v : '?');
